// This component renders a popup modal that allows users to select settings for creating a duplicate inspection based on a 
// previously completed inspection.
import { useState } from "react";

const DuplicateSettingsPopup = (props) => {
  const { onCancelPopup, OnSubmitPopup } = props;
  const [settingsData, setSettingsData] = useState({
    includeDetails: true,
    includeImages: true,
  });

  const handleFormChange = (e) => {
    const { name, checked } = e.target;
    setSettingsData({ ...settingsData, [name]: checked });
  };

  return (
    <div className="modal-overlay">
      <div className="approval-modal-content p-4" style={{ height: "auto" }}>
        <span className="close" onClick={onCancelPopup}>
          &times;
        </span>
        <h4 className="modal-header p-2 fw-semibold ">
          Create from Previous Inspection
        </h4>

        <div className="modal-body p-2">
          <div className="row">
            <span className="mb-1">
              Please choose the below settings to create duplicate insepction
              for the selected property based on previously completed inspection
              data.
            </span>
            <div className="d-flex align-items-start gap-2">
              <input
                className="custom-checkbox mt-1 form-check-input-checkbox"
                type="checkbox"
                id="includeDetails"
                name="includeDetails"
                // disabled={!isAppprovalPending}
                checked={settingsData.includeDetails}
                onChange={(e) => handleFormChange(e)}
              />
              <div>
                <p className="mb-0">Include details</p>
                {/* <p
                      className="marketing-description mb-0"
                      style={{ fontSize: "0.7rem" }}
                    >
                      (Disabling this will remove the consolidated action item,
                      though details of each door will be available in PDF)
                    </p> */}
              </div>
            </div>
            <div className="d-flex align-items-start gap-2">
              <input
                className="custom-checkbox mt-1 form-check-input-checkbox"
                type="checkbox"
                id="includeImages"
                name="includeImages"
                // disabled={!isAppprovalPending}
                checked={settingsData.includeImages}
                onChange={(e) => handleFormChange(e)}
              />
              <div>
                <p className="mb-0">Include Images</p>
                {/* <p
                      className="marketing-description mb-0"
                      style={{ fontSize: "0.7rem" }}
                    >
                      (Disabling this will remove the consolidated action item,
                      though details of each door will be available in PDF)
                    </p> */}
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap">
              <button
                type="button"
                className="btn btn-secondary fw-bold"
                onClick={onCancelPopup}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary fw-bold"
                onClick={() => OnSubmitPopup(settingsData)}
                // disabled={loading}
              >
                {/* {loading ? "Submitting..." : "Submit"} */}
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DuplicateSettingsPopup;
